import axiosInstance from "../services/axiosInstance";
import { normalizeBlobAPIError, throwIfBlobContainsAPIData } from "../services/blob-response";

const unwrap = (response) => {
  if (response.data?.success !== true) throw new Error(response.data?.message || "Request failed");
  return response.data.data;
};

export const organizationListExcelAPI = {
  async active() {
    return unwrap(await axiosInstance.get("/api/importjob/active"));
  },
  async history() {
    return unwrap(await axiosInstance.get("/api/importjob/history", { params: { module: "OL", limit: 5 } }));
  },
  async validate(file) {
    const form = new FormData();
    form.append("file", file);
    return unwrap(await axiosInstance.post("/org/company/validate_excel", form));
  },
  async import(file) {
    const form = new FormData();
    form.append("file", file);
    return unwrap(await axiosInstance.post("/org/company/import_excel", form));
  },
  async export(lang) {
    try {
      return await throwIfBlobContainsAPIData(await axiosInstance.post("/org/company/export_excel", null,
        { params: { lang }, responseType: "blob" }));
    } catch (error) { throw await normalizeBlobAPIError(error); }
  },
  async errorReport(jobId, lang) {
    try {
      return await throwIfBlobContainsAPIData(await axiosInstance.get(
        `/api/importjob/jobs/${encodeURIComponent(jobId)}/error-report`,
        { params: { lang }, responseType: "blob" }));
    } catch (error) { throw await normalizeBlobAPIError(error); }
  },
};

export function saveExcelDownload(response, fallback) {
  const disposition = response.headers?.["content-disposition"] || "";
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1];
  let name = /filename="([^"]+)"/i.exec(disposition)?.[1] || fallback;
  if (encoded) { try { name = decodeURIComponent(encoded); } catch (_) { /* Use fallback filename. */ } }
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = name.replace(/[\\/]/g, "_");
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
